<template>
	<main-filter>
		<div class="filters__item filters__item--3">
			<div class="filters__item--double">
				<InputText :label="'Поиск по компании'" :placeholder="'Введите название компании'" :input-gray="true" v-model="filter.company"/>
			</div>
		</div>

		<div class="filters__item">
			<ProductCategories v-model="filter.productGroups" ref="productGroups"/>
		</div>
		<div class="filters__item filters__item--2">
			<div class="filters__btns">
				<button type="submint" class="btn btn--color" @click="updateBlackList">Применить</button>
				<button class="btn btn--trans" @click="clearFilter();">Сбросить фильтр</button>
			</div>
		</div>
	</main-filter>
	<div class="table-card">
		<div class="table-wrap">
			<table class="table table--default" v-if="blackList?.items.length">
				<thead class="table__head">
				<tr class="table__row">
					<td class="table__col">№</td>
					<td class="table__col">Ответственные менеджеры</td>
					<td class="table__col">Наименование юр. лица</td>
					<td class="table__col">Товарная категория</td>
					<td class="table__col">Телефон</td>
					<template  v-if="['administrator', 'manager'].includes(getUserRole)">
						<td class="table__col">Действие</td>
						<td class="table__col"></td>
					</template>
				</tr>
				<tr class="table__margin">
					<td colspan="100%"></td>
				</tr>
				</thead>
				<tbody class="table__body">
				<template v-for="item in blackList.items" :key="item">
					<tr class="table__row">
						<td class="table__col">
							<span class="table__col-label">№ поставщика</span>
							<span class="table__col-cont">№{{ item.id }}</span>
						</td>
						<td class="table__col">
							<span class="table__col-label">Ответственные менеджеры</span>
							<span class="table__col-cont">{{getStringManagers(item.managers) || 'Не найдено' }}</span>
						</td>
						<td class="table__col">
							<span class="table__col-label">Наименование юр. лица</span>
							<span class="table__col-cont">{{ item.legalForm?.name }} {{ item.companyName }}</span>
						</td>
						<td class="table__col">
							<span class="table__col-label">Товарная категория</span>
							<span class="table__col-cont">{{getStringProductGroup(item.productGroups, 'name') || 'Не найдено' }}</span>
						</td>

						<td class="table__col">
							<span class="table__col-label">Телефон</span>
							<div class="table__col-phones">
								<div v-for="(phone, index) in item.phones" :key="index">
									<a  :href="`tel:${phone}`">+{{ phone }}</a>
								</div>
							</div>
						</td>
						<td  v-if="['administrator', 'manager'].includes(getUserRole)" class="table__col table__col--btn" colspan="2">
							<div class="table__btns">
								<button class="btn btn--border"  @click="selectedSupplier = item, ShowRestorePopup = true">Восстановить</button>
								<button class="link" @click="selectedSupplier = item,ShowBlackListPopup = true">Подробнее</button>
							</div>
						</td>
					</tr>
					<tr class="table__margin">
						<td colspan="100%"></td>
					</tr>
				</template>
				</tbody>
			</table>
			<div v-else class="table-card__empty">Поставщики не найдены</div>
		</div>

		<div class="pagination">
			<vue-awesome-paginate
				v-if="blackList?.countTotal > filter.limit"
				:total-items="+blackList?.countTotal"
				:max-pages-shown="3"
				:items-per-page="filter.limit"
				v-model="currentPage"
				:on-click="updateBlackList" />
		</div>

	</div>
	<transition name="modal">
		<BlackListPopup v-if="ShowBlackListPopup" :supplier="selectedSupplier" @openPopup="ShowRestorePopup = true"  @close="ShowBlackListPopup = false" />
	</transition>
	<transition name="modal">
		<RestorePopup v-if="ShowRestorePopup" :supplier="selectedSupplier" @refreshList="this.requestBlackList(filter)"  @close="ShowRestorePopup = false" />
	</transition>
	<PageLoader v-if="isLoading"/>
</template>

<script>
import MainFilter from "@/components/blocks/MainFilter.vue";
import ProductCategories from "@/components/blocks/ProductCategories.vue";
import BlackListPopup from "@/components/sections/BlackList/BlackListPopup.vue";
import RestorePopup from "@/components/sections/BlackList/RestorePopup.vue";
import PageLoader from "@/components/base/utils/PageLoader.vue";
import InputText from "@/components/base/utils/formElements/InputText.vue";
import {mapActions, mapGetters} from "vuex";


export default {
	name: "BlackListTable",
	components: {PageLoader,BlackListPopup, RestorePopup, MainFilter, ProductCategories, InputText},
	props: {
		productGroups: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			ShowBlackListPopup: false,
			ShowRestorePopup: false,
			selectedSupplier: {},
			currentPage: 1,
			filter: {
				productGroups: '',
				offset: 0,
				limit: 10,
				company: ''
			}
		}
	},
	async created() {
		await this.requestBlackList(this.filter)
	},
	methods: {
		getStringManagers(managers) {
			return managers.reduce((acc,item,index) => acc += `${item}${managers.length != index + 1 ? ', ' : " "}`,'')
		},
		getStringProductGroup(group,name) {
			return group.reduce((acc,item,index) => acc += `${item[name]}${group.length != index + 1 ? ', ' : "."}`,'')
		},
		clearFilter() {
			this.filter.company = ''
			this.$refs.productGroups.clearAll()
			this.updateBlackList()
		},

		async updateBlackList(value) {
			this.filter.offset = (value - 1) * this.filter.limit || 0
			await this.requestBlackList(this.filter)
		},
		...mapActions({
			requestBlackList: 'suppliers/requestBlackList',
		}),
	},
	computed: {
		...mapGetters({
			blackList: 'suppliers/getBlackList',
			isLoading: 'isLoading',
			getUserRole: 'user/getUserRole',
		})
	}
}
</script>


